import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./BlogCards.scss";
import { useSelector } from "react-redux";
import { selectAllBlogs, selectAllImages } from "../../selectors.js";

const BlogCards = () => {
  const data = useSelector(selectAllBlogs);
  const images = useSelector(selectAllImages);
  const [backgroundImage, setBackgroundImage] = useState(null);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleMouseEnter = (imgSrc) => {
    setBackgroundImage(imgSrc);
  };

  const handleMouseLeave = () => {
    setBackgroundImage(null);
  };
  return (
    <section
      className="blog-cards"
      style={{
        background: backgroundImage
          ? `url(${backgroundImage}) center/cover no-repeat`
          : "radial-gradient(circle, rgba(152,51,63,1) 0%, rgba(32,114,140,1) 100%)",
      }}
    >
      {data.map((post) => {
        const imgPath = images?.find((img) => img.key === post.image);
        return (
          <Link
            className="card"
            to={`/blogs/${post.path}`}
            onMouseEnter={() => handleMouseEnter(imgPath?.src)}
            onMouseLeave={handleMouseLeave}
          >
            <span className="image-container">
              <img src={imgPath.src} alt={post.title} />
            </span>
            <div class="card-content">
              <h2>{post.title}</h2>
              <p>{post.content}</p>
              <Link to={`/blogs/${post.path}`} className="button">
                Find out more
              </Link>
            </div>
          </Link>
        );
      })}
    </section>
  );
};

export default BlogCards;
